import React, { Component, useState } from 'react';
import { Form, Field } from 'react-final-form';
import RequiredLabel from '../RequiredLabel/RequiredLabel';
import Logic from '../../Logic';

const AutoCompleteField = (props) => {
  const [options, setOptions] = useState([]);

  function getAutocompleteOptions(input, query){
    input.onChange({
      Key: input.value.Key, //query && query.trim().length > 0 ? input.value.Key : null,
      Value: query
    });

    if(query.trim().length > 2){
      const logic = new Logic();
      logic.getAutocomplete(props.api, props.parentId, query, result => {
        setOptions(result);
      });
    }else{
      setOptions([]);
    } 
  }

  function selectOption(input, key, value){
    input.onChange({Key: key, Value: value});
    document.getElementById('query_'+props.name).value = value;
    setOptions([]);
  }

  return (
    <Field name={props.name}>
        {({ input, meta }) => (
          <div className={meta.error && meta.touched ? 'form-group has-danger col-sm-'+props.cols : !meta.error && meta.touched ? 'form-group has-success col-sm-'+props.cols : 'form-group col-sm-'+props.cols}>
          {props.required ? <RequiredLabel>{props.label}</RequiredLabel> : <label>{props.label}</label>}{meta.error && meta.touched && <div className="invalid-feedback" style={{display:'block'}}>{meta.error}</div>}
            <input {...input} type="hidden" className={meta.error && meta.touched ? 'form-control is-invalid' : !meta.error && meta.touched ? 'form-control is-valid' : 'form-control'} />
            <input type="text" tabIndex={props.tabIndex} value={input.value.Value} name={props.name.Value} autoComplete="off" id={'query_'+props.name} placeholder={props.placeholder} className={meta.error && meta.touched ? 'form-control is-invalid' : !meta.error && meta.touched ? 'form-control is-valid' : 'form-control'} placeholder={props.placeholder} onChange={event => getAutocompleteOptions(input, event.target.value)} />
            {options.length > 0 ? <div className={"dropdown-menu col-sm-12"} style={{display:'block', margin:'0', width:'90%', marginRight:'5%'}}> {options.map(option => <a className="dropdown-item" onClick={(event) => selectOption(input, option.Key, option.Value)} key={option.Key}>{option.Value}</a>)} </div> : null}
          </div>
        )}
    </Field>
  );
};

export default AutoCompleteField;
  